module.exports = __webpack_public_path__ + "img/icon_super_off_mini@3x.bfd28f34.png";